import { render } from "./Lazy.vue?vue&type=template&id=46258d92"
import script from "./Lazy.vue?vue&type=script&lang=js"
export * from "./Lazy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__